import { render } from "./CreateSubSequent.vue?vue&type=template&id=2893fc06"
import script from "./CreateSubSequent.vue?vue&type=script&lang=js"
export * from "./CreateSubSequent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__